import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import BuildingScopeAndGoals from "../../../environment-page-components/BuildingScopeAndGoals";
import LifeCycleInventory from "../../../environment-page-components/LifeCycleInventory";
import BuildingSectionsAccordion from "../components/BuildingSectionsAccordion";
import BIMUniformatTab from "./BIMUniformatTab";
import { Process } from "../../../db_access/process";
import { useContextProvider } from "../../../components/page-context/ContextProvider";
import { ORG_PALETTE } from "../../../theme/style/organizationPalette";

const WBLCATab = ({ building, selectedBuildingSection, setSelectedBuildingSection }) => {
  const { refresh } = useContextProvider();
  const [allProcesses, setAllProcesses] = useState([]);

  useEffect(() => {
    if (building?.id) {
      Process.get_by_building_ids([building.id])
        .then((response) => {
          if (!response.ok) throw new Error("Failed to fetch processes");
          return response.json();
        })
        .then((data) => {
          setAllProcesses(data);
        })
        .catch((err) => console.error("Error fetching all processes:", err));
    }
  }, [building?.id, refresh]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: ORG_PALETTE.spacing.sectionGap, fontFamily: "Poppins" }}>
      
      {/* 1. Scope & Goals */}
      <BuildingScopeAndGoals building={building} />

      {/* 2. Building Sections Accordion */}
      <BuildingSectionsAccordion
        building={building}
        selectedSection={selectedBuildingSection}
        onSectionSelect={setSelectedBuildingSection}
        allProcesses={allProcesses}
      />

      {/* 3 & 4. BIM IFC Model & Extracted Elements Grid */}
      <BIMUniformatTab
        building={building}
        selectedBuildingSection={selectedBuildingSection}
      />

      {/* 5. LCI Table (Process & Env Grid) */}
      <LifeCycleInventory
        title="Life Cycle Inventory"
        selectedID={building?.id}
        isSupplier={false}
        isReuse={false}
        buildingSection={selectedBuildingSection}
        onClearBuildingSection={() => setSelectedBuildingSection(null)}
      />
    </Box>
  );
};

export default WBLCATab;
